class CustomDatalayer {
	constructor() {
		this.ajaxFile = `${document.getElementById('uri').value}/AJAX/custom_datalayer.php`
		this.data = {}
		// console.log(window.dataLayer)
	}

	ajaxCall(action, data) {
		return new Promise((resolve, reject) => {
			let formData = new FormData();
			let request = new XMLHttpRequest();
			formData.append('action', action);
			formData.append('data', JSON.stringify(data));

			request.open('POST', this.ajaxFile, true);
			request.onreadystatechange = function () {
				if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
					let res = JSON.parse(request.response);
					if(res.return == 200){
						resolve(res);
					}
				}
			};
			request.send(formData);
		})
	}
	singleProductDataLayer(data) {
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "view_item",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	addToCartDataLayer(data){
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "add_to_cart",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	// removeFromCartDataLayer(data){
	// 	window.dataLayer = dataLayer || [];
	// 	//dataLayer.push({ ecommerce: null });
	// 	dataLayer.push({
	// 		event: "remove_from_cart",
	// 		ecommerce: {
	// 			currency: 'EUR',
	// 			value: data.price,
	// 			items: [
	// 				data.result
	// 			]
	// 		}
	// 	});
	// }
}

export {CustomDatalayer}